import axios from 'axios';

export const getUserSelf = async () => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/self`, { withCredentials: true });
	return data;
};

// ----- ORGANIZATIONS -----

export const getOrganizations = async () => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/organizations`, { withCredentials: true });
	return data;
};

export const createOrganization = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/organizations`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const editOrganization = async (id: string, payload: any) => {
	const { data } = await axios({
		method: 'put',
		url: `${process.env.API_URL}/api/backoffice/organizations/${id}`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const copyOrganization = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/organizations/copy-organization`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const clearDemoData = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/organizations/clear-demo-data`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

// ----- USERS -----

export const getWingopsUsers = async () => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/users`, { withCredentials: true });
	return data;
};

export const removeUserFromOrganization = async (userId: string, orgId: string) => {
	const { data } = await axios({
		method: 'delete',
		url: `${process.env.API_URL}/api/backoffice/organizations/${orgId}/users/${userId}`,
		data: {},
		withCredentials: true,
	});

	return data;
};

export const addUserToOrganization = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/users`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

// ----- FEATURES -----

export const toggleFeatures = async (payload: any) => {
	const { data } = await axios({
		method: 'put',
		url: `${process.env.API_URL}/api/backoffice/features`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

// ----- GLOBAL MESSAGES -----

export const getGlobalMessages = async (organizationId: string) => {
	const { data } = await axios.get(
		`${process.env.API_URL}/api/backoffice/organizations/${organizationId}/global-messages`,
		{ withCredentials: true }
	);
	return data;
};

export const createGlobalMessage = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/organizations/${payload.organization_id}/global-messages`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const removeGlobalMessage = async (organizationId: string, id: string) => {
	const { data } = await axios({
		method: 'delete',
		url: `${process.env.API_URL}/api/backoffice/organizations/${organizationId}/global-messages/${id}`,
		data: {},
		withCredentials: true,
	});

	return data;
};

// ----- ORGANIZATION BAKCUPS -----

export const updateOrganizationBackupsConfig = async (payload: any) => {
	const { data } = await axios({
		method: 'put',
		url: `${process.env.API_URL}/api/backoffice/organizations/${payload.organization_id}/organization-backups`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

// ----- AIRCRAFTS ----

export const getAircrafts = async () => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/aircrafts`, { withCredentials: true });
	return data;
};

export const editAircraft = async (id: string, payload: any) => {
	const { data } = await axios({
		method: 'put',
		url: `${process.env.API_URL}/api/backoffice/aircrafts/${id}`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

// ----- PUBLICATIONS -----

export const getPublications = async (params: any = {}) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/publications/list`,
		data: params,
		withCredentials: true,
	});

	return data;
};

export const getPublicationsUploadUrl = async (params: any = {}) => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/publications/upload-url`, {
		params,
		withCredentials: true,
	});
	return data;
};

export const getPublicationCrawlRuns = async (params: any = {}) => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/publications/crawl-runs`, {
		params,
		withCredentials: true,
	});
	return data;
};

export const getPublicationStats = async () => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/publications/stats`, {
		withCredentials: true,
	});
	return data;
};

export const createPublication = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/publications`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const updatePublication = async (id: string, payload: any) => {
	const { data } = await axios({
		method: 'put',
		url: `${process.env.API_URL}/api/backoffice/publications/${id}`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const deletePublication = async (id: string) => {
	const { data } = await axios({
		method: 'delete',
		url: `${process.env.API_URL}/api/backoffice/publications/${id}`,
		withCredentials: true,
	});

	return data;
};

export const getPublicationNotifications = async () => {
	const { data } = await axios.get(`${process.env.API_URL}/api/backoffice/publication-notifications`, {
		withCredentials: true,
	});
	return data;
};

export const createPublicationNotification = async (payload: any) => {
	const { data } = await axios({
		method: 'post',
		url: `${process.env.API_URL}/api/backoffice/publication-notifications`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const updatePublicationNotification = async (id: string, payload: any) => {
	const { data } = await axios({
		method: 'put',
		url: `${process.env.API_URL}/api/backoffice/publication-notifications/${id}`,
		data: payload,
		withCredentials: true,
	});

	return data;
};

export const deletePublicationNotification = async (id: string) => {
	const { data } = await axios({
		method: 'delete',
		url: `${process.env.API_URL}/api/backoffice/publication-notifications/${id}`,
		withCredentials: true,
	});

	return data;
};
